// Copyright (c) Docugami, Inc. All rights reserved.
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { DgButton } from 'components/common/DgCommonStyledComponents';
import { dgIconNames } from 'hooks/dgIcons';
import { emptyColor } from './AppStyles';
import { ErrorPageSubText } from 'components/common/Fonts';
import { IconRenderer } from 'components/work_path/IconRenderer';
import { Logger, LoggerCategory } from 'utils/Logger';
import { Config } from 'config';
import { useDgAuth } from 'hooks/DgAuthentication';
import { DgUnauthenticatedShell } from './Header';

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    max-height: 600px;
    width: 100%;
    align-self: center;
    justify-self: center;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: center;
`;

const RedirectButton = styled(DgButton)`
    width: fit-content;
    margin-top: 10px;
`;


export const CallbackPage = () => {
  const { handleRedirectCallback, logout } = useDgAuth();
  const [handleRedirectError, setHandleRedirectError] = useState(false);

  function onHandleRedirectError(error: any) {
    Logger.LogError(LoggerCategory.Authentication, "HandleRedirectUrl Failed", error);
    setHandleRedirectError(true);
  }

  useEffect(() => {
    // If we are not hosted in the office dialog
    if (!Office.context.ui || !Office.context.ui.messageParent) {
      handleRedirectCallback()
        .then((result) => {
          if (result.appState?.returnTo) {
            let returnUrl = result.appState?.returnTo
            if (!!result.appState["hash"]) {
              returnUrl += result.appState["hash"];
            }
            window.location.href = returnUrl
          } else {
            window.location.href = `${window.location.origin}/home/`
          }
        })
        .catch((error) => {
          onHandleRedirectError(error);
        })
    }
    else {
      handleRedirectCallback()
        .then(() => {
          Office.context.ui.messageParent(String(true));
        })
        .catch((error) => {
          onHandleRedirectError(error);
        })
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

  return handleRedirectError ? (
      <DgUnauthenticatedShell>
        <Root>
            <IconRenderer
                source={{
                    name: dgIconNames.DgRobotLarge,
                    height: 485,
                    width: 424,
                    defaultColor: emptyColor
                }}
                width={250}
                height={300} />
            <TextContainer>
                <ErrorPageSubText>Something went wrong.</ErrorPageSubText>
                <RedirectButton key={'retry_login'} onClick={() => logout({ returnTo: `${Config.baseUrl}` })}>Retry Login</RedirectButton>
            </TextContainer>
        </Root>
      </DgUnauthenticatedShell>) : <div></div>;
};
